export default __webpack_public_path__ + "static/media/blog-3.af339268.jpg";